import { render } from "./GenericTestResultsTable.vue?vue&type=template&id=00cc7f4c&scoped=true"
import script from "./GenericTestResultsTable.vue?vue&type=script&lang=js"
export * from "./GenericTestResultsTable.vue?vue&type=script&lang=js"

import "./GenericTestResultsTable.vue?vue&type=style&index=0&id=00cc7f4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cc7f4c"]])

export default __exports__